(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-bar-component')) {
    customElements.define(
      'promo-bar-component',
      class PromoBarComponent extends HTMLElement {
        connectedCallback() {
          this.initCopy();
          this.initCountdown();
        }

        disconnectedCallback() {
          this.clearTimers();
        }

        clearTimers() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          if (this.copyResetTimer) {
            clearTimeout(this.copyResetTimer);
            this.copyResetTimer = null;
          }
        }

        /* ---------- Click-to-copy promo code ---------- */

        initCopy() {
          this.copyButton = this.querySelector('[data-promo-code]');
          if (!this.copyButton) return;

          this.codeText = this.querySelector('[data-promo-code-text]');
          this.copiedText = this.querySelector('[data-promo-code-copied]');

          this.copyButton.addEventListener('click', () => this.copyCode());
        }

        copyCode() {
          if (this.copyResetTimer) return;

          const code = this.copyButton.dataset.promoCode;
          if (!code || !navigator.clipboard) return;

          navigator.clipboard
            .writeText(code)
            .then(() => {
              if (!this.codeText || !this.copiedText) return;

              this.codeText.hidden = true;
              this.copiedText.hidden = false;

              this.copyResetTimer = setTimeout(() => {
                this.codeText.hidden = false;
                this.copiedText.hidden = true;
                this.copyResetTimer = null;
              }, 2000);
            })
            .catch(() => {
              /* Clipboard blocked (insecure context or denied permission).
                 The code is still on screen as text, so nothing is lost. */
            });
        }

        /* ---------- Countdown ---------- */

        initCountdown() {
          const endAttr = this.dataset.countdownEnd;
          if (!endAttr) return;

          this.endTime = new Date(endAttr).getTime();
          if (Number.isNaN(this.endTime)) return;

          this.countdown = this.querySelector('[data-countdown]');
          if (!this.countdown) return;

          this.expiredBehavior = this.dataset.expiredBehavior || 'hide_timer';
          this.units = {
            days: this.querySelector('[data-countdown-days]'),
            hours: this.querySelector('[data-countdown-hours]'),
            minutes: this.querySelector('[data-countdown-minutes]'),
            seconds: this.querySelector('[data-countdown-seconds]'),
          };

          /* Tick immediately: Shopify may have cached the Liquid-rendered values
             well before this page was served, so they can be badly stale. */
          this.tick();
          if (this.endTime > Date.now()) {
            this.timer = setInterval(() => this.tick(), 1000);
          }
        }

        tick() {
          const remaining = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));

          if (remaining <= 0) {
            this.clearTimers();
            this.onExpired();
            return;
          }

          this.setUnit('days', Math.floor(remaining / 86400));
          this.setUnit('hours', Math.floor((remaining % 86400) / 3600));
          this.setUnit('minutes', Math.floor((remaining % 3600) / 60));
          this.setUnit('seconds', remaining % 60);
        }

        setUnit(name, value) {
          const el = this.units[name];
          if (!el) return;

          const next = String(value).padStart(2, '0');
          /* Skip no-op writes so only the seconds pill touches the DOM each tick. */
          if (el.textContent !== next) el.textContent = next;
        }

        onExpired() {
          ['days', 'hours', 'minutes', 'seconds'].forEach((name) => this.setUnit(name, 0));

          if (this.expiredBehavior === 'hide_bar') {
            this.hidden = true;
          } else if (this.expiredBehavior === 'hide_timer') {
            this.countdown.classList.add('promo-bar__countdown--hidden');
          }
          /* 'show_message' is resolved server-side; 'keep' intentionally leaves
             the frozen 00 pills on screen. Neither needs anything here. */
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
